import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "../src/style/coreStyle.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";

import i18n from './providers/i18n.jsx';
import ReactDOM from "react-dom/client";
import { isMobileDevice } from "./utils/utils.js";
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState, useEffect, Suspense, lazy } from "react";

import { Mp3PlayerProvider } from './providers/mp3PlayerContext.jsx';

import useEmail from "./utils/useEmail.js";
import GoogleAssistantLoader from "./comps/googleLoader.jsx";

import AudioLayout from "./layouts/audioLayout.jsx";
import HomeDesktop from "./routes/desktop/homeDesktop.jsx";
import HomeMobile from "./routes/mobile/homeMobile.jsx";

const Resume = lazy(() => import("./routes/common/resume.jsx"));
const Skills = lazy(() => import("./routes/common/skills.jsx"));
const Photos = lazy(() => import("./routes/common/photos.jsx"));
const TeamApp = lazy(() => import("./routes/common/teamApp.jsx"));
const Attenix = lazy(() => import("./routes/common/attenix.jsx"));
const AboutMe = lazy(() => import("./routes/common/aboutMe.jsx"));
const Projects = lazy(() => import("./routes/common/projects.jsx"));
const Asterisk = lazy(() => import("./routes/common/asterisk.jsx"));
const NotFound = lazy(() => import("./routes/common/notFound.jsx"));
const ShellySmart = lazy(() => import("./routes/common/shellySmart.jsx"));
const JustRunItTool = lazy(() => import("./routes/common/justRunIt.jsx"));
const GooglePhotos = lazy(() => import("./routes/common/googlePhotos.jsx"));
const AwsAppManager = lazy(() => import("./routes/common/awsAppManager.jsx"));

const WindowDialogs = lazy(() => import("./routes/common/windowDialogs.jsx"));

const LoadingFallback = () => (<GoogleAssistantLoader />);

const routerConfig = { future: { v7_startTransition: true, v7_relativeSplatPath: true } };


const ComponentBasedDevice = () => {

  const isDesktopMode = !isMobileDevice();
  const [isCssImport, setIsCssImport] = useState(false);

  useEffect(() => {
    const cssFileToImport = isDesktopMode ? "desktopStyle" : "mobileStyle";
    import(`./style/${cssFileToImport}.css`).then(() => {
      setTimeout(() => setIsCssImport(true), 50);
    });

  }, [isDesktopMode]);

  if (!isCssImport) return <LoadingFallback />;

  return (
    <I18nextProvider i18n={i18n}>
      <Mp3PlayerProvider>
        <BrowserRouter {...routerConfig}>
          <RouterComponent isDesktopMode={isDesktopMode} />
        </BrowserRouter>
      </Mp3PlayerProvider>
    </I18nextProvider>
  );
};

const RouterComponent = ({ isDesktopMode }) => {

  useEmail();

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {isDesktopMode ? (
          <Route path="/" element={<AudioLayout />}>
            <Route index element={<HomeDesktop />} />
            <Route path="*" element={<NotFound />} />
            <Route path="skills" element={<Skills />} />
            <Route path="resume" element={<Resume />} />
            <Route path="aboutMe" element={<AboutMe />} />
            <Route path="photos" element={<Photos />} />
            <Route path="projects" element={<Projects />} />
            <Route path="homePage" element={<HomeDesktop />} />
            <Route path="projects/teamApp" element={<TeamApp />} />
            <Route path="projects/attenix" element={<Attenix />} />

            <Route path="projects/asterisk" element={<Asterisk />} />
            <Route path="projects/shellySmart" element={<ShellySmart />} />
            <Route path="projects/justRunItTool" element={<JustRunItTool />} />
            <Route path="projects/awsAppManager" element={<AwsAppManager />} />
            <Route path="projects/windowDialogs" element={<WindowDialogs />} />
            <Route path="projects/googlePhotos" element={<GooglePhotos />} />
          </Route>
        ) : (
          <>
            <Route index element={<HomeMobile />} />
            <Route path="*" element={<NotFound />} />
            <Route path="skills" element={<Skills />} />
            <Route path="resume" element={<Resume />} />
            <Route path="aboutMe" element={<AboutMe />} />
            <Route path="photos" element={<Photos />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/attenix" element={<Attenix />} />
            <Route path="projects/teamApp" element={<TeamApp />} />
            <Route path="projects/asterisk" element={<Asterisk />} />
            <Route path="projects/shellySmart" element={<ShellySmart />} />
            <Route path="projects/justRunItTool" element={<JustRunItTool />} />
            <Route path="projects/windowDialogs" element={<WindowDialogs />} />
            <Route path="projects/googlePhotos" element={<GooglePhotos />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
};

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(<ComponentBasedDevice />);
